export default "__VITE_ASSET__79439869__"